import { format } from 'owa-string-utils';
import { parse as parseUrl, Url } from 'url';
import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import { API_BASE_FOR_SHARES } from 'owa-fileprovider-services';

const getFileInfoRequestUrlFormat: string =
    'https://{0}/{1}/{2}/?expand=sharepointIds,permission,driveItem(select=webDavUrl,name,folder,package)';

export function getFileInfoRequestUrlOneDrivePro(url: string) {
    const parsedUrl: Url = parseUrl(url);
    return format(
        getFileInfoRequestUrlFormat,
        parsedUrl.hostname,
        API_BASE_FOR_SHARES,
        getEncodedUrlForVroom(url)
    );
}
